import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getAiVisCssVars } from '../pages/ai-vis/aivisTheme';
import { isCampaignViewer } from '../pages/ai-vis/aivisRoles';
import '../pages/ai-vis/ai-vis.css';

/**
 * Blocks campaign viewers (clients) from reaching a route, redirecting them
 * to the AI Visibility dashboard. Used to keep hidden reports (e.g. Overview)
 * inaccessible via direct URL, not just hidden from the sidebar.
 */
export default function CampaignViewerRedirect({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="aivis-auth-page" style={getAiVisCssVars()}>
        <div className="aivis-loading-screen" role="status" aria-live="polite">
          <div className="aivis-loading-dot" />
          <span>Loading…</span>
        </div>
      </div>
    );
  }

  if (isCampaignViewer(user)) {
    return <Navigate to="/ai-vis/home" replace />;
  }

  return children;
}
